import { useEffect, useState } from "react";

import { TSummary } from "../@types";
import { apis, callApi } from "../api";

export type TMyLearningProgressService = {
	listeners: (() => void)[];
	loading: boolean;
	summaries: TSummary[];

	addEventListener: (cb: () => void) => void;
	clearData: () => void;
	emitChanges: () => void;
	removeEventListener: (cb: () => void) => void;

	setLoading: (loading: boolean) => void;
	setSummaries: (summaries: TSummary[]) => void;
};

export const MyLearningProgressService: TMyLearningProgressService = {
	listeners: [],
	loading: false,
	summaries: [],

	addEventListener(cb) {
		this.listeners = this.listeners.filter((listener) => listener !== cb);
		this.listeners.push(cb);
	},

	clearData() {
		this.loading = false;
		this.summaries = [];
		this.emitChanges();
	},

	emitChanges() {
		for (const listener of this.listeners) {
			listener();
		}
	},

	removeEventListener(cb) {
		this.listeners = this.listeners.filter((listener) => listener !== cb);
	},

	setLoading(loading) {
		this.loading = loading;
	},

	setSummaries(summaries) {
		this.summaries = summaries;
	},
};

export function useMyLearningProgressInit() {
	useEffect(() => {
		const getSummaries = async () => {
			try {
				MyLearningProgressService.setLoading(true);
				MyLearningProgressService.emitChanges();
				const response = await callApi({
					method: "GET",
					url: apis.SUMMARY_BY_STUDENT_TOKEN,
				});

				if (!response?.summaries) {
					return;
				}

				MyLearningProgressService.setSummaries(response.summaries);
			} catch (error) {
			} finally {
				MyLearningProgressService.setLoading(false);
				MyLearningProgressService.emitChanges();
			}
		};

		getSummaries();
	}, []);
}

export function useMyLearningProgress() {
	const [loading, setLoading] = useState(MyLearningProgressService.loading);
	const [summaries, setSummaries] = useState(
		MyLearningProgressService.summaries,
	);

	useEffect(() => {
		const updateData = () => {
			setLoading(MyLearningProgressService.loading);
			setSummaries(MyLearningProgressService.summaries);
		};

		MyLearningProgressService.addEventListener(updateData);

		return () => {
			MyLearningProgressService.removeEventListener(updateData);
		};
	}, []);

	return { loading, summaries };
}
